import { Injectable, inject } from '@angular/core'
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout'
import { Subject } from 'rxjs'
@Injectable()
export class BreakpointService {
  private breakpointObserver = inject(BreakpointObserver)

  public isDesktop = true
  public isLGDesktop = true
  public isXLDesktop = true
  public isXXLDesktop = true
  public isXXXLDesktop = true

  public sizeVar = new Subject<string>()
  public size$ = this.sizeVar.asObservable()

  public isDesktopVar = new Subject<boolean>()
  public isMobileVar = new Subject<boolean>()

  public isDesktop$ = this.isDesktopVar.asObservable()
  public isMobile$ = this.isMobileVar.asObservable()

  public expandListing = true

  constructor() {
    // NOTE: Use the Breakpoint Observer to switch observe
    //       mobile/desktop changes...
    this.breakpointObserver
      .observe(['(min-width: 992px)', '(min-width: 1200px)', '(min-width: 1400px)', '(min-width: 2000px)'],)
      .subscribe((state: BreakpointState) => {
        if (this.isDesktop !== state.matches) {
          this.isDesktop = state.matches
          this.isDesktopVar.next(state.matches)
          this.isMobileVar.next(!state.matches)
        }

        this.isLGDesktop = false
        this.isXLDesktop = false
        this.isXXLDesktop = false
        this.isXXXLDesktop = state.breakpoints['(min-width: 2000px)']
        if (this.isXXXLDesktop) {
          this.sizeVar.next('XXXLDesktop')
        } else {
          this.isXXLDesktop = state.breakpoints['(min-width: 1400px)']
          if (this.isXXLDesktop) {
            this.sizeVar.next('XXLDesktop')
          } else {
            this.isXLDesktop = state.breakpoints['(min-width: 1200px)']
            if (this.isXLDesktop) {
              this.sizeVar.next('XLDesktop')
            } else {
              this.isLGDesktop = state.breakpoints['(min-width: 992px)']
            }
            if (this.isLGDesktop) {
              this.sizeVar.next('LGDesktop')
            } else if (this.isDesktop) {
              this.sizeVar.next('desktop')
            } else {
              this.sizeVar.next('mobile')
            }
          }
        }
      })
  }

  public setExpandListing(value: boolean) {
    this.expandListing = value
  }
}
